import React, { useState, useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  InformationCircleIcon,
  PencilIcon,
  XIcon,
} from "@heroicons/react/outline";
import { ChevronRightIcon, CheckIcon } from "@heroicons/react/solid";
import { useHistory, useParams } from "react-router-dom";
import _get from "lodash/get";
import _sortBy from "lodash/sortBy";
import _omit from "lodash/omit";
import { format } from "date-fns";
import { Formik, Field, Form, ErrorMessage } from "formik";

import Tag from "components/lib/Shared/Tag";
import {
  ORG_ADMIN_OFFICIAL_REVIEW,
  ORG_ADMIN_OFFICIAL_REVIEW_II,
  getCompanySecretaryDocumentData,
  getDocumentData,
  getSignatureModuleData,
} from "components/PLCTABS/CompanyOfficialsTab/FileUploadForm/documentData";
import CommentsPopup from "components/lib/Global/CommentsPopup";
import ReactTable from "components/lib/Shared/ReactTable";
import FormFieldsCard from "components/lib/Global/FormFieldsCard";
import SpinnerIcon from "components/lib/Shared/Icons/SpinnerIcon";
import Tabs from "components/lib/Shared/Tabs";
import { INDIVIDUALS } from "components/PLCTABS/SFLdata/config/constants";
import CommentsList from "components/lib/Global/CommentsList";
import { addComment, editComment, getComments } from "state/slices/comment";
import { resolveFields, invalidateFields } from "state/slices/resolveField";
import {
  getBeneficialOwnershipFormFields,
  getFormFields,
  getFullName,
} from "utils";
import { useToast } from "hooks/useToast";
import Status from "components/PLCTABS/ApplicationReviewTab/Status";

import Checkbox from "components/lib/Shared/Checkbox";
import { getChangedDocumentsModuleData } from "config/documentData";
import { Constants } from "config/constants";
import {
  editInitiatedTransactionChangeAsync,
  transactionReviewAsync,
} from "state/slices/initiateTransactionChange";
import { handleFilesUpload } from "utils/filesUtils";
import { uploadTemplateFileAsync } from "state/slices/templateFile";
import Button from "components/lib/Shared/Button";
import { updateActiveDashboardState } from "state/slices/activeDashboard";
import { setCookie } from "utils/cookie";
import FileUploadForm from "components/PLCTABS/CompanyOfficialsTab/FileUploadForm";
import * as Yup from "yup";
import { ChevronLeftIcon } from "components/lib/Shared/Icons/sflIcons";
import ChangeDocumentSignature from "../Changes/SharedComponents/DocumentSignature/changeDocumnetSignature";

const validationSchema = Yup.object().shape({
  fileUploads: Yup.mixed().required("File uploads are required."),
});

function OfficialSubRow({
  visibleColumns,
  row,
  currentTab,
  initialRows = [],
  handleBackBtn,
  seniorJointShareholder = null,
  isSeniorJSReportable,
  isReviewer,
  isApprove,
  setCookieRole = () => null,
  onComplete,
  callFrom = "",
  isViewMode,
  onLastStepClose = () => null,
  actionType = "",
  ...restProps
}) {
  let updatedData;
  let isCOP = false;
  if (row.original.changeType === "CHANGE-OF-PARTICULARS") {
    isCOP = true;
    const originalOfficial = {
      ...row.original,
      name: row.original.names,
      electronicAddress: row.original.electronicAddress,
      postalAddress: row.original.postalAddress,
      residentialAddressDetails: row.original.residentialAddressDetails,
      identificationDetails: row.original.identificationDetails,
    };
    const excludedKeys = [
      "createdAt",
      "resolvedFields",
      "updatedAt",
      "createdBy",
      "individualID",
      "_id",
    ];
    function getUpdatedData(original, updated, excludedKeys = []) {
      const differences = {};

      for (const key in updated) {
        if (excludedKeys.includes(key)) {
          continue;
        }
        if (
          typeof updated[key] === "object" &&
          updated[key] !== null &&
          !Array.isArray(updated[key])
        ) {
          const nestedDifferences = getUpdatedData(
            original[key] || {},
            updated[key],
            excludedKeys
          );
          if (Object.keys(nestedDifferences).length > 0) {
            differences[key] = nestedDifferences;
          }
        } else if (updated[key] !== original[key]) {
          differences[key] = updated[key];
        }
      }

      return differences;
    }

    updatedData = getUpdatedData(
      originalOfficial,
      row.original.updatedOfficial,
      excludedKeys
    );
  }

  const history = useHistory();
  const [selectedTabIndex, setSelectedTabIndex] = useState(
    row.original.status === "CHANGES-SIGNATURE" ? 3 : 0
  );
  const [selectedFiles, setSelectedFiles] = useState({});
  const [singeDocPayload, setSingeDocPayload] = useState([]);
  const dispatch = useDispatch();
  // history.location.pathname.split("/").pop() === "view" ||
  // restProps.isViewMode;
  const isReviewerMode = true;
  // history.location.pathname.split("/").pop() === "review";
  const isCompanyDashboard =
    history.location.pathname.split("/").pop() === "dashboard";
  const currentUser = useSelector((state) => state.userSlice);
  const { beneficialOwners } = useSelector(
    (state) => state.beneficialOwnersTableSlice
  );
  const params = useParams();
  const { toast } = useToast(4000);

  const [disableSubmitBtn, setDisableSubmitBtn] = useState(true);
  const [agreeToSubmit, setAgreeToSubmit] = useState(false);
  const [agreeToTerms, setAgreeToTerms] = useState(false);
  const [brsRefNumber, setBrsRefNumber] = useState(
    row.original?.orgAdminReview?.brsRefNumber || ""
  );
  const [errorMessage, setErrorMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [confirmationCheckBox, setConfirmationCheckBox] = useState(false);
  const [legalDepartmentEmployees, setLegalDepartmentEmployees] = useState([]);

  const [showOrgAdminSuccessModal, setShowOrgAdminSuccessModal] =
    useState(false);
  const [role, setRole] = useState();
  const [fillingReceipt, setFillingReceipt] = useState(false);
  const { comments } = useSelector((state) => state.commentsSlice);

  const officialComments = comments.filter(
    (comment) =>
      comment?.officialId &&
      comment.officialId === row.original._id &&
      comment?.tabName
  );
  const generalInformationComments = officialComments.filter(
    (comment) =>
      comment.formName === "identificationDetails" ||
      comment.formName === "names" ||
      comment.formName === "identificationDetails" ||
      comment.formName === "isDirector"
  );
  const appointerComments = officialComments.filter(
    (comment) => comment.formName === "appointers"
  );
  const residentialDetailsComments = officialComments.filter(
    (comment) =>
      comment.formName === "postalAddress" ||
      comment.formName === "electronicAddress" ||
      comment.formName === "residentialAddressDetails" ||
      comment.formName === "isNonResident"
  );
  const officialShareAllocationComments = officialComments.filter(
    (comment) => comment.formName === "officialShareAllocation"
  );
  const officialBeneficialOwnershipComments = officialComments.filter(
    (comment) => comment.formName === "beneficialOwnershipForm"
  );
  const fileUploadComments = officialComments.filter(
    (comment) => comment.formName === "uploadDocuments"
  );
  const changeDocumentsComments = comments.filter(
    (comment) => comment.formName === "uploadChangeDocuments"
  );
  const adminDocumentsComments = comments.filter(
    (comment) => comment.formName === "adminDocumentsSignature"
  );
  const initialTabs = [
    ...(row.original.applicationType === "Alternate Director" &&
    row.original.changeType === "APPOINTMENT"
      ? [
          {
            id: "appointer",
            label: "Appointer",
            // commentsCount: generalInformationComments.length,
          },
        ]
      : []),
    {
      id: "generalInformation",
      label: "General information",
      commentsCount: generalInformationComments.length,
    },
    ...(row.original.changeType !== "CESSATION"
      ? [
          {
            id: "residentialDetails",
            label: "Address Details",
            commentsCount: residentialDetailsComments.length,
          },
        ]
      : []),
    ...(row.original.changeType !== "CESSATION"
      ? [
          {
            id: "fileUploads",
            label: "KYC Documents",
            commentsCount: fileUploadComments.length,
          },
        ]
      : []),

    {
      id: "changedDocuments",
      label: "Change Documents",
      commentsCount: 0,
    },
    // {
    //   id: "directorApprovalDocs",
    //   label: "Approval Documents (Director)",
    //   commentsCount: 0,
    // },
    // ...(row.original?.designation === "Joint Shareholder"
    //   ? [
    //     {
    //       id: "jointShareholderApprovalDocs",
    //       label: "Approval Documents (JS)",
    //       commentsCount: 10,
    //     },
    //   ]
    //   : []),
    ...(row.original.status === "DIRECTOR-REVIEW-APPROVAL" ||
    row.original.status === "ADMIN-REVIEW-II"
      ? [
          {
            id: "manualBridge",
            label: "Manual Bridge",
          },
        ]
      : []),
    ...(row.original.status === "ADMIN-REVIEW-APPROVAL" ||
    row.original.status === "BRS-REVIEW"
      ? [
          {
            id: "brsUploads",
            label: "BRS Uploads",
          },
        ]
      : []),
    ...(row.original.status === "DIRECTOR-REVIEW-APPROVAL" ||
    row.original.status === "BRS-REVIEW"
      ? [
          {
            id: "confirmation",
            label: "Status",
          },
        ]
      : []),
  ];

  const showOfficialShareAllocationTab =
    row.original?.sharesAllotted?.length > 0;
  const showBOTab = row.original?.beneficialOwnershipForm;

  const tabs = useMemo(() => {
    let tempTabs = [];

    let isSeniorJSReportable = false;
    if (seniorJointShareholder?.beneficialOwnershipForm) {
      const {
        directPercentShareholding,
        directPercentVotingRights,
        directRightRemoveDirector,
        directCompanyControlRight,
      } = seniorJointShareholder?.beneficialOwnershipForm;
      isSeniorJSReportable =
        directPercentShareholding >= 10 ||
        directPercentVotingRights >= 10 ||
        directRightRemoveDirector === "yes" ||
        directCompanyControlRight === "yes";
    }

    if (
      ["Director", "Authorized Person", "Company Secretary"].includes(
        row.original?.designation
      )
    ) {
      tempTabs = [
        {
          id: "generalInformation",
          label: "General information",
          commentsCount: generalInformationComments?.length,
        },
        {
          id: "residentialDetails",
          label: "Address details",
          commentsCount: residentialDetailsComments?.length,
        },
        {
          id: "uploadDocuments",
          label: "File Uploads",
          commentsCount: fileUploadComments?.length,
        },
      ];
    } else if (row.original?.designation === "Joint Shareholder") {
      if (
        seniorJointShareholder &&
        row.original._id === seniorJointShareholder._id
      ) {
        tempTabs = [
          {
            id: "generalInformation",
            label: "General Information",
            commentsCount: generalInformationComments?.length,
          },
          {
            id: "residentialDetails",
            label: "Address Details",
            commentsCount: residentialDetailsComments?.length,
          },
          {
            id: "officialShareAllocation",
            label: "Share information",
            commentsCount: officialShareAllocationComments?.length,
          },
          {
            id: "officialBeneficialOwnership",
            label: "Beneficial ownership",
            commentsCount: officialBeneficialOwnershipComments?.length,
          },
          {
            id: "uploadDocuments",
            label: "Upload Documents",
            commentsCount: fileUploadComments?.length,
          },
        ];
      } else {
        tempTabs = [
          {
            id: "generalInformation",
            label: "General Information",
            commentsCount: generalInformationComments?.length,
          },
          row.original.isDirector === "Yes" || isSeniorJSReportable
            ? {
                id: "residentialDetails",
                label: "Address Details",
                commentsCount: residentialDetailsComments?.length,
              }
            : null,
          {
            id: "uploadDocuments",
            label: "Upload Documents",
            commentsCount: fileUploadComments?.length,
          },
        ];
      }
    } else {
      tempTabs = [
        ...(row.original.applicationType === "Alternate Director" &&
        row.original.changeType === "APPOINTMENT"
          ? [
              {
                id: "appointer",
                label: "Appointer",
                // commentsCount: generalInformationComments.length,
              },
            ]
          : []),
        {
          id: "generalInformation",
          label: "General information",
          commentsCount: generalInformationComments?.length,
        },
        row.original.changeType !== "CESSATION"
          ? {
              id: "residentialDetails",
              label: "Address details",
              commentsCount: residentialDetailsComments?.length,
            }
          : null,
        showOfficialShareAllocationTab
          ? {
              id: "officialShareAllocation",
              label: "Share information",
              commentsCount: officialShareAllocationComments?.length,
            }
          : null,
        showBOTab
          ? {
              id: "officialBeneficialOwnership",
              label: "Beneficial ownership",
              commentsCount: officialBeneficialOwnershipComments?.length,
            }
          : null,
        {
          id: "uploadDocuments",
          label: "File Uploads",
          commentsCount: fileUploadComments?.length,
        },
      ];
    }
    if (currentTab === "beneficialOwnership") {
      tempTabs = [
        {
          id: "generalInformation",
          label: "General information",
          commentsCount: generalInformationComments?.length,
        },
        {
          id: "residentialDetails",
          label: "Address details",
          commentsCount: residentialDetailsComments?.length,
        },
        {
          id: "officialBeneficialOwnership",
          label: "Beneficial ownership",
          commentsCount: officialBeneficialOwnershipComments?.length,
        },
        {
          id: "uploadDocuments",
          label: "File Uploads",
          commentsCount: fileUploadComments?.length,
        },
      ];
    }
    return tempTabs.filter(Boolean);
  }, [
    row.original?.designation,
    currentTab,
    generalInformationComments?.length,
    residentialDetailsComments?.length,
    fileUploadComments?.length,
    showOfficialShareAllocationTab,
    officialShareAllocationComments?.length,
    showBOTab,
    officialBeneficialOwnershipComments?.length,
    seniorJointShareholder,
  ]);

  let orgAdminReviewDocuments = [];
  if (row.original.orgAdminReview) {
    orgAdminReviewDocuments = row.original.orgAdminReview.fileUploads.reduce(
      (acc, item) => {
        acc[item.fileType] = item.fileName;
        return acc;
      },
      {}
    );
  }
  const [selectedTab, setSelectedTab] = useState(tabs[0]);
  const goToPrevStep = () => {
    if (selectedTabIndex === 0 && handleBackBtn) handleBackBtn();
    else setSelectedTabIndex(selectedTabIndex - 1);
    setManualBridge(false);
  };

  const checkValidation = async (validateFormik) => {
    const isValid = await validateAllFields(validateFormik);
    if (isValid) {
      setSelectedTabIndex((prevIndex) => prevIndex + 1);
    }
  };
  const goToNextStep = async () => {
    setSelectedTabIndex(selectedTabIndex + 1);
    setManualBridge(false);
  };
  const { getEmployee } = useSelector((state) => state.employeeSlice);

  useEffect(() => {
    if (getEmployee?.items) {
      setLegalDepartmentEmployees(
        getEmployee.items.filter(
          (employee) => employee.isLegalDepartment === true
        )
      );
    }
  }, [getEmployee]);
  useEffect(() => {
    const tempSelectedTab = tabs[selectedTabIndex];
    if (tempSelectedTab) setSelectedTab(tempSelectedTab);
  }, [tabs, selectedTabIndex]);

  let dateOfBirth = _get(row.original.identificationDetails, "dateOfBirth");
  if (dateOfBirth) dateOfBirth = format(new Date(dateOfBirth), "yyyy/MM/dd");
  else dateOfBirth = "N/A";

  // approve/disapprove allotted shares to official
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRows, setSelectedRow] = useState([]);
  const [allFieldsResolved, setAllFieldsResolved] = useState(false);
  const [manualBridge, setManualBridge] = useState(false);
  const formId = _get(row.original, "_id");
  const resolvedFields = _get(row.original, "resolvedFields", []);

  const fieldsName = row.original?.sharesAllotted
    ?.map((share) => share.classOfShares)
    .filter(Boolean); // all the shares category names

  useEffect(() => {
    setAllFieldsResolved(
      fieldsName?.every((element) => resolvedFields.includes(element))
    );
  }, [fieldsName, resolvedFields]);

  // if (
  //     jointShareholderForReview.length > 0 &&
  //     row.original?.JSGroupID &&
  //     row.original.idType === "Joint Shareholder"
  // ) {
  //     return (
  //         <tr className="bg-[#EDF0F5]">
  //             <td colSpan={visibleColumns.length} className="p-9">
  //                 <StakeholderTable
  //                     data={_sortBy(jointShareholderForReview, ["JSGroupOrder"])}
  //                     currentTab={currentTab}
  //                     isJointShareholderTable
  //                 />
  //             </td>
  //         </tr>
  //     );
  // }
  const { manageCompanyTransactions } = useSelector(
    (state) => state.companyDashboardSlice
  );
  const { initiatedTransactions, getInitiatedTransactions } = useSelector(
    (state) => state.initiatedTransactionsSlice
  );
  const trxIndex = initiatedTransactions.items.findIndex(
    (item) => item._id === row.original.trxId
  );
  const officialSliceName = `initiatedTransactionsSlice.initiatedTransactions.items.${trxIndex}.officials.${row.original.officialIndex}`;
  const companyOfficialEffectKey = "updateOfficialManageModuleState";

  useEffect(() => {
    const tempSelectedTab = initialTabs[selectedTabIndex];
    if (tempSelectedTab) setSelectedTab(tempSelectedTab);
  }, [selectedTabIndex]);

  let unresolvedComments = comments.filter((comment) => !comment.isResolved);

  const submitToLabel =
    unresolvedComments.length !== 0
      ? "applicant"
      : isReviewer
      ? "admin"
      : "BRS";

  const isFirstStep = selectedTabIndex === 0;
  const isLastStep = initialTabs.length - 1 === selectedTabIndex;

  let nextBtnLabel = isLastStep
    ? isViewMode
      ? "Back to Transactions Page"
      : `Submit to ${submitToLabel}`
    : isViewMode
    ? "Next Step"
    : "Confirm details";

  const handleSaveComment = async (data) => {
    if (data?.commentId) {
      await dispatch(editComment({ commentId: data.commentId, data }));
    } else {
      await dispatch(
        addComment({
          data: {
            ...data,
            company: params.companyId,
            officialId: row.original._id,
            tabName: selectedTab.id,
          },
        })
      );
    }
  };

  function createUploadFilePayloads(uploadedFiles, companyId, officialId) {
    return Object.keys(uploadedFiles).map((key) => {
      return {
        company: companyId,
        official: officialId,
        fileType: key,
        fileName: uploadedFiles[key],
        modeType: "pre-signed-documents",
        subModeType: "self-resolution-type",
      };
    });
  }
  const handleResolveBtnClicked = async (fieldName) => {
    // approve field
    const commentsToBeResolved = officialShareAllocationComments?.filter(
      (comment) => comment.fieldName === fieldName && !comment.isResolved
    );
    const commentsToBeResolvedIds = commentsToBeResolved?.map(({ _id }) => _id);
    setIsLoading(true);
    setSelectedRow((selectedRows) => [...selectedRows, fieldName]);
    const promise = await dispatch(
      resolveFields({
        data: {
          formId,
          formName: ["changedDocuments", "directorApprovalDocs"].includes(
            selectedTab.id
          )
            ? "ManagerCompanyDocument"
            : INDIVIDUALS.includes(row?.original?.idType)
            ? "individualOfficial"
            : "corporateOfficial",

          fieldName,
          resolvedFields: [fieldName],
          commentsToBeResolvedIds,
        },
        updateEffectKey: companyOfficialEffectKey,
        updateEffectPath: officialSliceName,
      })
    );
    if (commentsToBeResolvedIds.length > 0) {
      const query = { companyId: commentsToBeResolved[0]?.company };
      if (isReviewerMode) query.createdBy = currentUser?._id;
      await dispatch(getComments(query));
    }
    setIsLoading(false);
    setSelectedRow((selectedRows) => [
      ...selectedRows.filter(
        (rowName) => rowName !== promise.meta.arg.data.fieldName
      ),
    ]);
  };

  const handleInvalidateBtnClicked = async (fieldName) => {
    // disapprove field
    setIsLoading(true);
    setSelectedRow((selectedRows) => [...selectedRows, fieldName]);
    const promise = await dispatch(
      invalidateFields({
        data: {
          formId,
          formName: ["changedDocuments", "directorApprovalDocs"].includes(
            selectedTab.id
          )
            ? "ManagerCompanyDocument"
            : INDIVIDUALS.includes(row?.original?.idType)
            ? "individualOfficial"
            : "corporateOfficial",
          fieldName,
          invalidFields: [fieldName],
        },
        updateEffectKey: companyOfficialEffectKey,
        updateEffectPath: officialSliceName,
      })
    );
    setIsLoading(false);
    setSelectedRow((selectedRows) => [
      ...selectedRows.filter(
        (rowName) => rowName !== promise.meta.arg.data.fieldName
      ),
    ]);
  };

  const handleAllFieldsStatus = async (e) => {
    const commentsToBeResolved = officialShareAllocationComments?.filter(
      (comment) => !comment.isResolved
    );
    const commentsToBeResolvedIds = commentsToBeResolved?.map(({ _id }) => _id);
    setIsLoading(true);
    if (e.target.checked) {
      // resolve/approve all the form fields
      const unresolvedFields = fieldsName.filter(
        (fieldName) => !resolvedFields.includes(fieldName)
      );
      setSelectedRow((selectedRows) => [...selectedRows, ...unresolvedFields]);
      await dispatch(
        resolveFields({
          data: {
            formId,
            formName: ["changedDocuments", "directorApprovalDocs"].includes(
              selectedTab.id
            )
              ? "ManagerCompanyDocument"
              : INDIVIDUALS.includes(row?.original?.idType)
              ? "individualOfficial"
              : "corporateOfficial",
            resolvedFields: unresolvedFields,
            commentsToBeResolvedIds,
          },
          updateEffectKey: companyOfficialEffectKey,
          updateEffectPath: officialSliceName,
        })
      );
      if (commentsToBeResolvedIds.length > 0) {
        const query = { companyId: commentsToBeResolved[0]?.company };
        if (isReviewerMode) query.createdBy = currentUser?._id;
        await dispatch(getComments(query));
      }
      setIsLoading(false);
      setSelectedRow([]);
    } else {
      // invalidate/disapprove all the form fields
      const resolvedFieldsSlice = fieldsName.filter((fieldName) =>
        resolvedFields.includes(fieldName)
      );
      setSelectedRow((selectedRows) => [
        ...selectedRows,
        ...resolvedFieldsSlice,
      ]);
      await dispatch(
        invalidateFields({
          data: {
            formId,
            formName: ["changedDocuments", "directorApprovalDocs"].includes(
              selectedTab.id
            )
              ? "ManagerCompanyDocument"
              : INDIVIDUALS.includes(row?.original?.idType)
              ? "individualOfficial"
              : "corporateOfficial",
            invalidFields: resolvedFieldsSlice,
          },
          updateEffectKey: companyOfficialEffectKey,
          updateEffectPath: officialSliceName,
        })
      );
      setSelectedRow([]);
    }
    setIsLoading(false);
  };

  const officialShareAllocationColumns = [
    {
      Header: "Class of shares",
      Cell: ({ row }) => row.original.classOfShares,
    },
    { Header: "Number of Shares", accessor: "allottedShares" },
    {
      Header: "Value Of Shares",
      Cell: ({ row }) => (
        <div className="inline-flex items-baseline">
          <span className="px-1 text-xs font-medium">KES</span>{" "}
          <Tag>{row.original.sharesValue}</Tag>
        </div>
      ),
    },
    { Header: "Paid Up Shares", accessor: "paidUpShares" },
    {
      Header: "Premium Paid",
      Cell: ({ row }) => (
        <div className="inline-flex items-baseline">
          <span className="px-1 text-xs font-medium">KES</span>{" "}
          <Tag>{row.original.sharePremium}</Tag>
        </div>
      ),
    },
    {
      Header: "Nominal Value",
      Cell: ({ row }) => (
        <div className="inline-flex items-baseline">
          <span className="px-1 text-xs font-medium">KES</span>{" "}
          <Tag>{row.original.nominalValue}</Tag>
        </div>
      ),
    },
    {
      Header: "Voting Rights",
      Cell: ({ row }) => row.original.votingRights,
    },
  ];

  if (!isViewMode && !isCompanyDashboard) {
    officialShareAllocationColumns.push({
      Header: "Action",
      Cell: ({ row }) => {
        const isRowLoading =
          isLoading && selectedRows.includes(row.original.classOfShares);
        return (
          <div className="flex items-center space-x-2">
            {!resolvedFields.includes(row.original.classOfShares) && (
              <CommentsPopup
                handleSaveComment={handleSaveComment}
                formName="officialShareAllocation"
                fieldName={row.original.classOfShares}
                fieldLabel={row.original.classOfShares}
                comment={officialShareAllocationComments.find(
                  (comment) =>
                    comment.fieldName === row.original.classOfShares &&
                    currentUser?._id === comment.createdBy?._id
                )}
              >
                <span>Review</span>
                <PencilIcon className="inline w-4 h-4" />
              </CommentsPopup>
            )}
            <div className={`flex items-center justify-center pr-4`}>
              {resolvedFields.includes(row.original.classOfShares) ? (
                <button
                  className={`flex space-x-1 ${
                    isRowLoading ? "cursor-not-allowed" : "cursor-pointer"
                  }`}
                  onClick={() =>
                    isRowLoading
                      ? null
                      : handleInvalidateBtnClicked(row.original.classOfShares)
                  }
                >
                  {isRowLoading ? (
                    <SpinnerIcon className="text-primary" />
                  ) : (
                    <>
                      <span>Accepted</span>
                      <XIcon className="inline w-4 h-4" />
                    </>
                  )}
                </button>
              ) : (
                <button
                  className={`flex space-x-1 ${
                    isRowLoading ? "cursor-not-allowed" : "cursor-pointer"
                  }`}
                  onClick={() =>
                    isRowLoading
                      ? null
                      : handleResolveBtnClicked(row.original.classOfShares)
                  }
                >
                  {isRowLoading ? (
                    <SpinnerIcon className="text-primary" />
                  ) : (
                    <>
                      <span>Accept</span>
                      <CheckIcon className="inline w-4 h-4" />
                    </>
                  )}
                </button>
              )}
            </div>
          </div>
        );
      },
    });
  }
  const validateAllFields = async (validateFormik) => {
    const formikErrors = await validateFormik();
    if (!brsRefNumber) {
      setErrorMessage("BRS Reference Number is required.");
      return false;
    }

    if (Object.keys(formikErrors).length > 0) {
      return false;
    }
    setErrorMessage("");
    return true;
  };
  const handleInputChange = (e) => {
    setBrsRefNumber(e.target.value);
  };

  const handleConfirmDetails = async () => {
    setSubmitting(true);
    try {
      await handleSubmitApplication();

      row.toggleRowExpanded();
      const nextRow = initialRows?.[row.index + 1] || null;
      if (nextRow) nextRow?.getToggleRowExpandedProps()?.onClick();
    } catch (error) {
      console.error("Error in handleConfirmDetails:", error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleSubmitApplication = async () => {
    let status = "";
    let toastMessage = "";
    try {
      switch (row.original.status) {
        case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_APPROVAL:
          ({ status, toastMessage } = handleDirectorApproval());
          break;
        case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_REVIEW:
          ({ status, toastMessage, unresolvedComments } =
            handleDirectorApproval());
          break;

        case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_APPROVAL:
          ({ status, toastMessage, unresolvedComments } =
            handleRegistrarApproval());
          break;
        case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_REVIEW:
          ({ status, toastMessage, unresolvedComments } =
            await handleDirectorReview());
          break;
        case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_REVIEW_II:
          ({ status, toastMessage, unresolvedComments } =
            await handleDirectorReview());
          break;
        case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES
          .DIRECTOR_REVIEW_APPROVAL:
          ({ status, toastMessage, unresolvedComments } =
            await handleAdminReview());
          break;
        case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.ADMIN_REVIEW:
          ({ status, toastMessage, unresolvedComments } =
            await handleAdminApprove());
          break;
        case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.ADMIN_REVIEW_II:
          ({ status, toastMessage, unresolvedComments } =
            await handleAdminReview());
          break;
        // case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.ADMIN_APPROVAL:
        //   ({ status, toastMessage, unresolvedComments } =
        //     handleBRSReview());
        // break;
        case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.BRS_REVIEW:
          ({ status, toastMessage, unresolvedComments } = handleBRSReview());
          break;
        case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.BRS_REVIEW_II:
          ({ status, toastMessage, unresolvedComments } = handleBRSReview());
          break;
        case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_CS_REVIEW:
          ({ status, toastMessage, unresolvedComments } = handleCSReview());
          break;
        case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_CS_APPROVAL:
          ({ status, toastMessage, unresolvedComments } = handleCSApproval());
          break;
        case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.LEGAL_REVIEW:
          ({ status, toastMessage, unresolvedComments } =
            handleLegalDepartmentReview());
          break;
        case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.LEGAL_APPROVAL:
          ({ status, toastMessage, unresolvedComments } =
            handleLegalDepartmentApproval());
          break;
        case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_DR_REVIEW:
          ({ status, toastMessage, unresolvedComments } = handleDRReview());
          break;
        case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_DR_APPROVAL:
          ({ status, toastMessage, unresolvedComments } = handleDRApproval());
          break;
        case Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.CHANGES_SIGNATURE:
          ({ status, toastMessage, unresolvedComments } = handleDRApproval());
          break;
        default:
          console.warn("Unknown status");
          break;
      }

      await dispatch(
        transactionReviewAsync({
          companyId: row.original.companyId,
          data: {
            trxRef: row.original.trxRef,
            officialId: row.originalId,
            status,
            infoForEmailToBeSent: {
              name: row.original.names.firstName,
              email: row.original.electronicAddress.emailAddress,
              reviewer: currentUser.names.firstName,
              companyName: row.original.company.companyName1WithSuffix,
              unresolvedCommentsCount: unresolvedComments?.length,
            },
          },
        })
      );
      toast("success", toastMessage);
      !showOrgAdminSuccessModal &&
        status !== "ADMIN-REVIEW-II" &&
        onComplete("Review is done successfully");
    } catch (error) {
      console.error("Error in handleSubmitApplication:", error);
    }
  };

  const handleDirectorApproval = () => {
    let status = "";
    let toastMessage = "";

    if (unresolvedComments.length > 0) {
      status = Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_CORRECTION;
      toastMessage =
        "The Application sent back to applicant to make corrections";
    } else {
      const isSignatureDocsNeeded =
        Constants.MAINTAIN_COMPANY_SIGNATURE_WORKFLOW.includes(
          row.original.status
        ) &&
        row.original.changeDocumentSignature.required &&
        Object.keys(row.original.changeDocumentSignature.fileUploads).length ===
          0;

      const isDirectorSignatureDocsNeeded =
        row.original.uploadDirectorApprovalDocs.modeType ===
        "not-signed-documents";
      if (isApprove) {
        if (legalDepartmentEmployees.length > 0) {
          status = Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.LEGAL_REVIEW;
          toastMessage = "The Application sent to Legal Department for review";
        } else if (isSignatureDocsNeeded) {
          status = Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.CHANGES_SIGNATURE;
          toastMessage = "The Application sent to Official for signature";
        } else if (isDirectorSignatureDocsNeeded) {
          status =
            Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_APPROVAL;

          toastMessage = "The Application sent to Director for Review";
        } else {
          status =
            Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_REVIEW_APPROVAL;
          toastMessage = "The Application sent to Admin for review";
        }
      } else {
        status = Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_REVIEW;
        toastMessage = "The Application sent to Registrar for approval";
      }
    }

    return { status, toastMessage, unresolvedComments };
  };

  const handleRegistrarApproval = () => {
    let status = "";
    let toastMessage = "";

    const isSignatureDocsNeeded =
      row.original.uploadDirectorApprovalDocs.modeType ===
      "not-signed-documents";
    if (unresolvedComments.length > 0) {
      status = Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_CORRECTION;
      toastMessage =
        "The Application sent back to applicant to make corrections";
    } else {
      status = isApprove
        ? isSignatureDocsNeeded
          ? Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_SIGNATURE
          : Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_REVIEW_APPROVAL
        : Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_REVIEW;

      toastMessage = isSignatureDocsNeeded
        ? "The Application sent to Director for Signature"
        : "The Application sent to Admin for Review";
    }
    return { status, toastMessage, unresolvedComments };
  };
  const handleDirectorReview = async () => {
    let status = "";
    let toastMessage = "";

    if (unresolvedComments.length > 0) {
      status =
        Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_REVIEW_CORRECTIONS;
      toastMessage =
        "The Application sent back to applicant to make corrections";
    } else {
      status =
        Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_REVIEW_APPROVAL;
      toastMessage = "The Application sent to Org Admin for review";
    }

    return { status, toastMessage, unresolvedComments };
  };

  const handleAdminReview = async () => {
    let status = "";
    let toastMessage = "";
    if (unresolvedComments.length > 0) {
      await orgAdminReviewI();
      status = Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.ADMIN_CORRECTIONS;
      toastMessage =
        "The Application sent back to applicant to make corrections";
      return { status, toastMessage };
    } else {
      await orgAdminReviewI();
      status = isApprove
        ? Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.BRS_FORM_SIGNATURE
        : Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.ADMIN_REVIEW;
      toastMessage = "The Application is Submitted";
      return { status, toastMessage, unresolvedComments };
    }
  };
  const handleAdminApprove = async () => {
    let status = "";
    let toastMessage = "";
    if (unresolvedComments.length > 0) {
      await orgAdminReviewI();
      status = Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.ADMIN_CORRECTIONS;
      toastMessage =
        "The Application sent back to applicant to make corrections";
      return { status, toastMessage };
    } else {
      await orgAdminReviewI();
      status = Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.BRS_FORM_SIGNATURE;
      toastMessage = "The Application is Submitted for  Registrar Signature";
      return { status, toastMessage, unresolvedComments };
    }
  };

  const handleBRSReview = () => {
    let status = "";
    let toastMessage = "";

    if (unresolvedComments.length > 0) {
      status = Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.BRS_REVIEW_CORRECTION;
      toastMessage =
        "The Application sent back to applicant to make corrections";
    } else {
      // orgAdminReviewII();
      status = isApprove
        ? Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.PROCESSED
        : (toastMessage = "The Application is Successfully Processed");
    }
    return { status, toastMessage, unresolvedComments };
  };
  const handleCSReview = () => {
    let status = "";
    let toastMessage = "";

    if (unresolvedComments.length > 0) {
      status =
        Constants.MAINTAIN_COMPANY_REVIEW_STATUSES
          .CHANGES_SIGNATURE_CORRECTIONS;
      toastMessage =
        "The Application sent back to applicant to make corrections";
    } else {
      const isDirectorSignatureDocsNeeded =
        row.original.uploadDirectorApprovalDocs.modeType ===
        "not-signed-documents";
      status = isApprove
        ? isDirectorSignatureDocsNeeded
          ? Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_APPROVAL
          : Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_REVIEW_APPROVAL
        : Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_CS_APPROVAL;
      toastMessage = "The Application is Submitted Successfully";
    }
    return { status, toastMessage, unresolvedComments };
  };
  const handleCSApproval = () => {
    let status = "";
    let toastMessage = "";

    if (unresolvedComments.length > 0) {
      status =
        Constants.MAINTAIN_COMPANY_REVIEW_STATUSES
          .CHANGES_SIGNATURE_CORRECTIONS;
      toastMessage =
        "The Application sent back to applicant to make corrections";
    } else {
      const isDirectorSignatureDocsNeeded =
        row.original.uploadDirectorApprovalDocs.modeType ===
        "not-signed-documents";
      status = isDirectorSignatureDocsNeeded
        ? Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_APPROVAL
        : Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_REVIEW_APPROVAL;
      toastMessage = "The Application is Submitted Successfully";
    }
    return { status, toastMessage, unresolvedComments };
  };
  const handleDRReview = () => {
    let status = "";
    let toastMessage = "";

    if (unresolvedComments.length > 0) {
      status =
        Constants.MAINTAIN_COMPANY_REVIEW_STATUSES
          .DIRECTOR_SIGNATURE_CORRECTIONS;
      toastMessage =
        "The Application sent back to applicant to make corrections";
    } else {
      status = isApprove
        ? Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_REVIEW_APPROVAL
        : Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_DR_APPROVAL;
      toastMessage = isApprove
        ? "The Application is Submitted for Admin for Review"
        : "The Application is Submitted for Registrar for Approve";
    }
    return { status, toastMessage, unresolvedComments };
  };
  const handleDRApproval = () => {
    let status = "";
    let toastMessage = "";

    if (unresolvedComments.length > 0) {
      status =
        Constants.MAINTAIN_COMPANY_REVIEW_STATUSES
          .DIRECTOR_SIGNATURE_CORRECTIONS;
      toastMessage =
        "The Application sent back to applicant to make corrections";
    } else {
      status =
        Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_REVIEW_APPROVAL;
      toastMessage = "The Application is Submitted for Admin for Review";
    }
    return { status, toastMessage, unresolvedComments };
  };
  const handleLegalDepartmentReview = () => {
    let status = "";
    let toastMessage = "";
    if (unresolvedComments.length > 0) {
      status = Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.LEGAL_CORRECTION;
      toastMessage =
        "The Application sent back to applicant to make corrections";
    } else {
      const isSignatureDocsNeeded =
        Constants.MAINTAIN_COMPANY_SIGNATURE_WORKFLOW.includes(
          row.original.status
        ) &&
        row.original?.changeDocumentSignature?.required &&
        Object.keys(row.original.changeDocumentSignature.fileUploads).length ===
          0;
      const isDirectorSignatureDocsNeeded =
        row.original.uploadDirectorApprovalDocs.modeType ===
        "not-signed-documents";

      isApprove
        ? isSignatureDocsNeeded
          ? (status =
              Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.CHANGES_SIGNATURE)
          : isDirectorSignatureDocsNeeded
          ? (status =
              Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_APPROVAL)
          : (status =
              Constants.MAINTAIN_COMPANY_REVIEW_STATUSES
                .DIRECTOR_REVIEW_APPROVAL)
        : (status = Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.LEGAL_APPROVAL);

      toastMessage = isSignatureDocsNeeded
        ? "The Application sent to Official for signature"
        : isDirectorSignatureDocsNeeded
        ? "The Application sent to Director for review"
        : "The Application sent to Admin for review";
    }
    return { status, toastMessage, unresolvedComments };
  };
  const handleLegalDepartmentApproval = () => {
    let status = "";
    let toastMessage = "";
    if (unresolvedComments.length > 0) {
      status = Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_CORRECTION;
      toastMessage =
        "The Application sent back to applicant to make corrections";
    } else {
      const isSignatureDocsNeeded =
        Constants.MAINTAIN_COMPANY_SIGNATURE_WORKFLOW.includes(
          row.original.status
        ) &&
        row.original.changeDocumentSignature.required &&
        Object.keys(row.original.changeDocumentSignature.fileUploads).length ===
          0;
      const isDirectorSignatureDocsNeeded =
        row.original.uploadDirectorApprovalDocs.modeType ===
        "not-signed-documents";
      isSignatureDocsNeeded
        ? (status =
            Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.CHANGES_SIGNATURE)
        : isDirectorSignatureDocsNeeded
        ? (status =
            Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_APPROVAL)
        : (status =
            Constants.MAINTAIN_COMPANY_REVIEW_STATUSES
              .DIRECTOR_REVIEW_APPROVAL);
      toastMessage = isSignatureDocsNeeded
        ? "The Application sent to Official for signature"
        : isDirectorSignatureDocsNeeded
        ? "The Application sent to Director for review"
        : "The Application sent to Admin for review";
    }
    return { status, toastMessage, unresolvedComments };
  };
  const orgAdminReviewI = async () => {
    const files = {
      Cr6Form: selectedFiles.selectedFiles.Cr6Form,
      Cr8Form: selectedFiles.selectedFiles.Cr8Form,
      BoDResolutionsChanges: selectedFiles.selectedFiles.BoDResolutionsChanges,
    };
    try {
      const uploadedFiles = await handleFilesUpload(files);
      const uploadFilePayloads = createUploadFilePayloads(
        uploadedFiles,
        row.original.companyId,
        row.originalId
      );

      const uploadPromises = uploadFilePayloads.map((payload) =>
        dispatch(uploadTemplateFileAsync({ data: payload })).then(
          (result) => result.payload.document._id
        )
      );

      const uploadedFilesDataIds = await Promise.all(uploadPromises);
      const orgAdminReviewPayload = {
        brsRefNumber: brsRefNumber,
        fileUploads: uploadedFilesDataIds,
        resolvedFields: [],
        documentId: row.original._id,
      };

      await dispatch(
        editInitiatedTransactionChangeAsync({
          companyId: row.original.companyId,
          formData: orgAdminReviewPayload,
        })
      );
      return "Org Admin Review updated successfully";
    } catch (error) {
      console.error("Error in orgAdminReviewI:", error);
      throw error;
    }
  };

  const showModalForDuration = async (duration) => {
    await new Promise((resolve) => setTimeout(resolve, duration));
    setShowOrgAdminSuccessModal(false);
  };

  const orgAdminReviewII = async () => {
    if (row?.original.orgAdminReviewII.fileUploads.length > 0) {
      await brsFillingReceiptUpload();
    }

    setShowOrgAdminSuccessModal(true);
    await showModalForDuration(6000);

    const breadCrumbs = [
      { name: "My Companies", href: "/companies", current: false },
      {
        name: `${row.original.companyId}`,
        href: "#",
        current: true,
      },
    ];

    const newRole = Constants.COOKIE_ROLES.ORG_ADMIN;
    setCookie("role", newRole);
    setCookieRole(newRole);
    setCookie("role", newRole);
    dispatch(
      updateActiveDashboardState({
        organizationName: row.original.company.companyName1WithSuffix,
        dashboardUrl: "",
        breadCrumbs,
      })
    );
    history.push("/");
  };
  function transformOrgAdminFileUploads(orgAdminReview) {
    const result = {};

    if (orgAdminReview && orgAdminReview.fileUploads) {
      orgAdminReview.fileUploads.forEach((fileUpload) => {
        result[fileUpload.fileType] = fileUpload.fileName;
      });
    }
    return result;
  }

  const brsFillingReceiptUpload = async () => {
    setFillingReceipt(true);
    const files = {
      brsFillingReceipt: selectedFiles.selectedFiles.brsFillingReceipt,
    };
    try {
      const uploadedFiles = await handleFilesUpload(files);
      const uploadFilePayloads = createUploadFilePayloads(
        uploadedFiles,
        row.original.companyId,
        row.originalId
      );

      const uploadPromises = uploadFilePayloads.map((payload) =>
        dispatch(uploadTemplateFileAsync({ data: payload })).then(
          (result) => result.payload.document._id
        )
      );

      const uploadedFilesDataIds = await Promise.all(uploadPromises);

      const orgAdminReviewIIPayload = {
        fileUploads: uploadedFilesDataIds,
        resolvedFields: [],
        documentId: row.original._id,
        currentReviewStep: "org-admin-II",
      };

      await dispatch(
        editInitiatedTransactionChangeAsync({
          companyId: row.original.companyId,
          formData: orgAdminReviewIIPayload,
        })
      );
      setFillingReceipt(false);
      return "Org Admin Review II updated successfully";
    } catch (error) {
      console.error("Error in orgAdminReviewI:", error);
      throw error;
    }
  };
  const datesFormFields = [
    {
      key: `Effective Date of Becoming`,
      name: `appointmentDate`,
      value: row.original.appointmentDate
        ? format(new Date(row.original.appointmentDate), "yyyy-MM-dd")
        : "N/A",
    },
    ...(row.original.changeType === "CHANGE-OF-PARTICULARS"
      ? [
          {
            key: `Effective Date of Change `,
            name: `dateOfCeasingToBeA`,
            value: row.original.changeOfParticularDate
              ? format(
                  new Date(row.original.changeOfParticularDate),
                  "yyyy-MM-dd"
                )
              : "N/A",
          },
        ]
      : []),
    ...(row.original.changeType === "CESSATION"
      ? [
          {
            key: `Effective Date of Change`,
            name: `dateOfRemoval`,
            value: row.original.cessationDate
              ? format(new Date(row.original.cessationDate), "yyyy-MM-dd")
              : "N/A",
          },
        ]
      : []),
  ];

  return (
    <tr className="bg-[#EDF0F5]">
      <td
        colSpan={visibleColumns.length}
        className={`px-9 ${isCompanyDashboard ? "pb-7" : ""}`}
      >
        <div className="flex flex-col">
          <div className=" mt-4 mb-4">
            <div className="rounded-md bg-sky-50 p-4">
              <div className="flex">
                <div className="flex-shrink-0">
                  <InformationCircleIcon
                    className="h-5 w-5 text-sky-400"
                    aria-hidden="true"
                  />
                </div>
                <div className="ml-3 flex-1 md:flex md:justify-between whitespace-normal">
                  <p className="text-sm text-sky-700">
                    Please confirm if the data submitted is correct. If not,
                    please leave comments which will be amended by the
                    applicant.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {showOrgAdminSuccessModal && (
            <div className="relative px-6">
              <div
                id="popup-modal"
                tabindex="-1"
                className="fixed inset-0 flex items-center justify-center"
              >
                <div className="absolute inset-0 bg-gray-800 opacity-75"></div>
                <div className="relative p-6 w-full max-w-md">
                  <div className="relative bg-white rounded-lg shadow dark:bg-gray-800">
                    <div className="p-6 text-center">
                      <svg
                        className="mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 20 20"
                      >
                        <path
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1-18 0Z"
                        />
                      </svg>
                      <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                        Your Application has been submitted Successfully!
                      </h3>
                      <p className="text-gray-700">
                        You will be redirected to the dashboard screen in a few
                        seconds. If something goes wrong, please click manually
                        and go to the dashboard.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div>
            <Tabs
              tabs={initialTabs}
              selectedTabIndex={selectedTabIndex}
              setSelectedTabIndex={setSelectedTabIndex}
            />
            {selectedTab.id === "appointer" && (
              <>
                {appointerComments && appointerComments.length > 0 && (
                  <div className="px-8 pt-5 pb-6 mt-6 bg-white">
                    <CommentsList
                      comments={appointerComments}
                      toggleCommentStatus={false}
                    />
                    <p className="mt-6 text-sm text-primary">
                      Comments: {appointerComments.length} of{" "}
                      {appointerComments.length}
                    </p>
                  </div>
                )}
                <FormFieldsCard
                  handleSaveComment={handleSaveComment}
                  fields={[
                    {
                      name: "appointers",
                      value: Array.isArray(row.original?.appointerNames)
                        ? row.original.appointerNames
                            .map((item) => getFullName(item) || "N/A")
                            .join(", ")
                        : row.original?.appointerNames ?? "N/A",
                    },
                  ]}
                  resolvedFields={_get(row.original, "resolvedFields")}
                  addReviewComment={isViewMode ? false : true}
                  hideResolveAllCheckbox={
                    isViewMode
                      ? true
                      : isCOP
                      ? updatedData.names
                        ? false
                        : true
                      : false
                  }
                  isReviewer={isReviewer}
                  isApprove={isApprove}
                  formName="appointers"
                  formHelperKey={"individualOfficial"}
                  updateEffectKey={companyOfficialEffectKey}
                  updateEffectPath={officialSliceName}
                  formId={_get(row.original, "_id")}
                  comments={appointerComments.filter(
                    (comment) => comment.formName === "appointers"
                  )}
                />
              </>
            )}
            {selectedTab.id === "generalInformation" && (
              <>
                {generalInformationComments &&
                  generalInformationComments.length > 0 && (
                    <div className="px-8 pt-5 pb-6 mt-6 bg-white">
                      <CommentsList
                        comments={generalInformationComments}
                        toggleCommentStatus={false}
                      />
                      <p className="mt-6 text-sm text-primary">
                        Comments: {generalInformationComments.length} of{" "}
                        {generalInformationComments.length}
                      </p>
                    </div>
                  )}
                {row.original.designation === "Joint Shareholder" && (
                  <FormFieldsCard
                    handleSaveComment={handleSaveComment}
                    fields={[
                      {
                        key: "Is Director",
                        name: "isDirector",
                        value: row.original?.isDirector ?? "N/A",
                      },
                    ]}
                    resolvedFields={_get(row.original, "resolvedFields")}
                    addReviewComment={true}
                    hideResolveAllCheckbox={false}
                    isReviewer={isReviewer}
                    isApprove={isApprove}
                    formName="isDirector"
                    formHelperKey={
                      selectedTab.id === "stakeholderTab"
                        ? "individualOfficial"
                        : "beneficialOwner"
                    }
                    updateEffectKey={companyOfficialEffectKey}
                    updateEffectPath={officialSliceName}
                    formId={_get(row.original, "_id")}
                    comments={generalInformationComments.filter(
                      (comment) => comment.formName === "isDirector"
                    )}
                  />
                )}
                {row.original.changeType !== "CESSATION" && (
                  <>
                    <FormFieldsCard
                      handleSaveComment={handleSaveComment}
                      fields={getFormFields({
                        idType: row?.original?.idType,
                        formType: "names",
                        formValues: row?.original?.names,
                      })}
                      previousData={updatedData && updatedData?.names}
                      resolvedFields={_get(
                        row?.original?.names,
                        "resolvedFields"
                      )}
                      addReviewComment={
                        isViewMode
                          ? false
                          : isCOP
                          ? updatedData.names
                            ? true
                            : false
                          : true
                      }
                      showToolTip={
                        isCOP ? (updatedData.names ? true : false) : false
                      }
                      hideResolveAllCheckbox={
                        isViewMode
                          ? true
                          : isCOP
                          ? updatedData.names
                            ? false
                            : true
                          : false
                      }
                      isReviewer={isReviewer}
                      isApprove={isApprove}
                      formName="names"
                      formHelperKey="names"
                      updateEffectKey={companyOfficialEffectKey}
                      updateEffectPath={`${officialSliceName}.names`}
                      formId={_get(row.original.names, "_id")}
                      comments={generalInformationComments.filter(
                        (comment) => comment.formName === "names"
                      )}
                      isViewMode={isViewMode}
                    />
                    <FormFieldsCard
                      handleSaveComment={handleSaveComment}
                      previousData={
                        updatedData && updatedData?.identificationDetails
                      }
                      fields={getFormFields({
                        idType: row.original?.idType,
                        formType: "identificationDetails",
                        formValues: row.original.identificationDetails,
                      })}
                      isReviewer={isReviewer}
                      isApprove={isApprove}
                      isViewMode={false}
                      resolvedFields={_get(
                        row.original.identificationDetails,
                        "resolvedFields"
                      )}
                      addReviewComment={
                        isCOP
                          ? updatedData?.identificationDetails
                            ? true
                            : false
                          : true
                      }
                      hideResolveAllCheckbox={
                        isViewMode
                          ? true
                          : isCOP
                          ? updatedData.identificationDetails
                            ? false
                            : true
                          : false
                      }
                      formName="identificationDetails"
                      formHelperKey="identificationDetails"
                      updateEffectKey={companyOfficialEffectKey}
                      updateEffectPath={`${officialSliceName}.identificationDetails`}
                      formId={_get(row.original.identificationDetails, "_id")}
                      comments={generalInformationComments.filter(
                        (comment) =>
                          comment.formName === "identificationDetails"
                      )}
                      files={row.original.fileUploads}
                    />
                  </>
                )}
                <FormFieldsCard
                  fields={datesFormFields}
                  hideResolveAllCheckbox={true}
                  addReviewComment={false}
                  isViewMode={isViewMode}
                />
                {[
                  "Local Company",
                  "Foreign Company",
                  "Other e.g Parastatals",
                ].includes(row.original?.idType) && (
                  <FormFieldsCard
                    handleSaveComment={handleSaveComment}
                    fields={getFormFields({
                      idType: row.original?.idType,
                      formType: "contactPersonInfo",
                      formValues: row.original.identificationDetails,
                    })}
                    isReviewer={isReviewer}
                    isApprove={isApprove}
                    resolvedFields={_get(
                      row.original.identificationDetails,
                      "resolvedFields"
                    )}
                    isViewMode={isViewMode}
                    addReviewComment={true}
                    hideResolveAllCheckbox={
                      isViewMode
                        ? true
                        : isCOP
                        ? updatedData.identificationDetails
                          ? false
                          : true
                        : false
                    }
                    formName="identificationDetails"
                    formHelperKey="identificationDetails"
                    updateEffectKey={companyOfficialEffectKey}
                    updateEffectPath={`${officialSliceName}.identificationDetails`}
                    formId={_get(row.original.identificationDetails, "_id")}
                    comments={generalInformationComments.filter(
                      (comment) => comment.formName === "identificationDetails"
                    )}
                  />
                )}
              </>
            )}
            {selectedTab.id === "residentialDetails" && (
              <>
                {residentialDetailsComments &&
                  residentialDetailsComments.length > 0 && (
                    <div className="px-8 pt-5 pb-6 mt-6 bg-white">
                      <CommentsList
                        comments={residentialDetailsComments}
                        toggleCommentStatus={false}
                      />
                      <p className="mt-6 text-sm text-primary">
                        Comments: {residentialDetailsComments.length} of{" "}
                        {residentialDetailsComments.length}
                      </p>
                    </div>
                  )}
                {row.original?.idType === "Kenyan Citizen" && (
                  <FormFieldsCard
                    handleSaveComment={handleSaveComment}
                    fields={[
                      {
                        key: "Non-Resident",
                        name: "isNonResident",
                        value: row.original?.isNonResident ?? "N/A",
                      },
                    ]}
                    isReviewer={isReviewer}
                    isApprove={isApprove}
                    resolvedFields={_get(row.original, "resolvedFields")}
                    addReviewComment={true}
                    hideResolveAllCheckbox={false}
                    formName="isNonResident"
                    formHelperKey={
                      selectedTab.id !== "stakeholderTab"
                        ? INDIVIDUALS.includes(row.original?.idType)
                          ? "individualOfficial"
                          : "corporateOfficial"
                        : "beneficialOwner"
                    }
                    updateEffectKey={companyOfficialEffectKey}
                    updateEffectPath={officialSliceName}
                    isViewMode={isViewMode}
                    formId={_get(row.original, "_id")}
                    comments={residentialDetailsComments.filter(
                      (comment) => comment.formName === "isNonResident"
                    )}
                  />
                )}
                <FormFieldsCard
                  handleSaveComment={handleSaveComment}
                  previousData={updatedData && updatedData?.postalAddress}
                  fields={getFormFields({
                    idType:
                      row.original?.isNonResident === "Yes"
                        ? "Foreigner"
                        : row.original?.idType,
                    formType: "postalAddress",
                    formValues: row.original?.postalAddress,
                  })}
                  resolvedFields={_get(
                    row.original?.postalAddress,
                    "resolvedFields"
                  )}
                  isReviewer={isReviewer}
                  isApprove={isApprove}
                  addReviewComment={
                    isCOP ? (updatedData.postalAddress ? true : false) : true
                  }
                  isViewMode={isViewMode}
                  hideResolveAllCheckbox={
                    isViewMode
                      ? true
                      : isCOP
                      ? updatedData.postalAddress
                        ? false
                        : true
                      : false
                  }
                  formName="postalAddress"
                  formHelperKey="postalAddress"
                  updateEffectKey={companyOfficialEffectKey}
                  updateEffectPath={`${officialSliceName}.postalAddress`}
                  formId={_get(row.original?.postalAddress, "_id")}
                  comments={residentialDetailsComments.filter(
                    (comment) => comment.formName === "postalAddress"
                  )}
                />
                <FormFieldsCard
                  handleSaveComment={handleSaveComment}
                  previousData={updatedData && updatedData?.electronicAddress}
                  fields={getFormFields({
                    idType: row.original?.idType,
                    formType: "electronicAddress",
                    formValues: row.original?.electronicAddress,
                  })}
                  resolvedFields={_get(
                    row.original.electronicAddress,
                    "resolvedFields"
                  )}
                  isReviewer={isReviewer}
                  isApprove={isApprove}
                  isViewMode={isViewMode}
                  addReviewComment={
                    isCOP
                      ? updatedData?.electronicAddress
                        ? true
                        : false
                      : true
                  }
                  hideResolveAllCheckbox={
                    isViewMode
                      ? true
                      : isCOP
                      ? updatedData.electronicAddress
                        ? false
                        : true
                      : false
                  }
                  formName="electronicAddress"
                  formHelperKey="electronicAddress"
                  updateEffectKey={companyOfficialEffectKey}
                  updateEffectPath={`${officialSliceName}.electronicAddress`}
                  formId={_get(row.original.electronicAddress, "_id")}
                  comments={residentialDetailsComments.filter(
                    (comment) => comment.formName === "electronicAddress"
                  )}
                />
                <FormFieldsCard
                  handleSaveComment={handleSaveComment}
                  previousData={
                    updatedData && updatedData?.residentialAddressDetails
                  }
                  fields={getFormFields({
                    idType:
                      row.original?.isNonResident &&
                      row.original?.isNonResident === "Yes"
                        ? "Foreigner"
                        : row.original?.idType,
                    formType: "residentialAddressDetails",
                    formValues: row.original?.residentialAddressDetails,
                  })}
                  isReviewer={isReviewer}
                  isApprove={isApprove}
                  resolvedFields={_get(
                    row.original.residentialAddressDetails,
                    "resolvedFields"
                  )}
                  isViewMode={isViewMode}
                  addReviewComment={
                    isCOP
                      ? updatedData.residentialAddressDetails
                        ? true
                        : false
                      : true
                  }
                  hideResolveAllCheckbox={
                    isViewMode
                      ? true
                      : isCOP
                      ? updatedData.residentialAddressDetails
                        ? false
                        : true
                      : false
                  }
                  formName="residentialAddressDetails"
                  formHelperKey="residentialAddressDetails"
                  updateEffectKey={companyOfficialEffectKey}
                  updateEffectPath={`${officialSliceName}.residentialAddressDetails`}
                  formId={_get(row.original.residentialAddressDetails, "_id")}
                  comments={residentialDetailsComments.filter(
                    (comment) =>
                      comment.formName === "residentialAddressDetails"
                  )}
                />
              </>
            )}
            {selectedTab.id === "officialShareAllocation" && (
              <>
                {officialShareAllocationComments &&
                  officialShareAllocationComments.length > 0 && (
                    <div className="px-8 pt-5 pb-6 my-6 bg-white">
                      <CommentsList
                        comments={officialShareAllocationComments}
                        toggleCommentStatus={!isViewMode}
                      />
                      <p className="mt-6 text-sm text-primary">
                        Comments: {officialShareAllocationComments.length} of{" "}
                        {officialShareAllocationComments.length}
                      </p>
                    </div>
                  )}
                {row.original.sharesAllotted?.length > 0 ? (
                  <div className="w-full bg-white shadow">
                    <div className="w-full overflow-x-auto">
                      <ReactTable
                        columns={officialShareAllocationColumns}
                        data={row.original.sharesAllotted}
                        dataRowStyle="h-12 text-sm leading-none text-gray-700 bg-white border-t border-b border-gray-200 hover:bg-gray-50"
                      />
                    </div>
                  </div>
                ) : (
                  <p className="mt-4 text-center">No data available</p>
                )}
                {!isCompanyDashboard &&
                  !isViewMode &&
                  row.original.sharesAllotted?.length > 0 && (
                    <div className="flex items-center mt-2">
                      <input
                        aria-describedby="comments-description"
                        type="checkbox"
                        className="mr-2 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                        onChange={handleAllFieldsStatus}
                        checked={allFieldsResolved}
                      />
                      <p className="flex items-center text-sm font-semibold">
                        Click this checkbox to{" "}
                        {allFieldsResolved ? "disapprove" : "approve"} all
                        entries if they are{" "}
                        {allFieldsResolved ? "incorrect" : "correct"} then
                        proceed to next step
                      </p>
                    </div>
                  )}
              </>
            )}
            {selectedTab.id === "officialBeneficialOwnership" && (
              <>
                {officialBeneficialOwnershipComments &&
                  officialBeneficialOwnershipComments.length > 0 && (
                    <div className="px-8 pt-5 pb-6 mt-6 bg-white">
                      <CommentsList
                        comments={officialBeneficialOwnershipComments}
                        toggleCommentStatus={!isViewMode}
                      />
                      <p className="mt-6 text-sm text-primary">
                        Comments: {officialBeneficialOwnershipComments.length}{" "}
                        of {officialBeneficialOwnershipComments.length}
                      </p>
                    </div>
                  )}
                <FormFieldsCard
                  handleSaveComment={handleSaveComment}
                  isReviewer={isReviewer}
                  isApprove={isApprove}
                  fields={getBeneficialOwnershipFormFields({
                    beneficialOwnershipForm:
                      row.original.beneficialOwnershipForm,
                    reviewTab: true,
                    beneficialOwner: row.original,
                    beneficialOwners,
                  })}
                  resolvedFields={_get(
                    row.original.beneficialOwnershipForm,
                    "resolvedFields"
                  )}
                  addReviewComment={!isCompanyDashboard && !isViewMode}
                  hideResolveAllCheckbox={isCompanyDashboard || isViewMode}
                  formName="beneficialOwnershipForm"
                  formHelperKey="beneficialOwnershipForm"
                  updateEffectKey={companyOfficialEffectKey}
                  updateEffectPath={`${officialSliceName}.beneficialOwnershipForm`}
                  formId={_get(row.original.beneficialOwnershipForm, "_id")}
                  comments={officialBeneficialOwnershipComments}
                />
              </>
            )}
            {selectedTab.id === "fileUploads" && (
              <>
                {fileUploadComments && fileUploadComments.length > 0 && (
                  <div className="px-8 pt-5 pb-6 mt-6 bg-white">
                    <CommentsList
                      comments={fileUploadComments}
                      toggleCommentStatus={false}
                    />
                    <p className="mt-6 text-sm text-primary">
                      Comments: {fileUploadComments.length} of{" "}
                      {fileUploadComments.length}
                    </p>
                  </div>
                )}
                <div className="px-8 pt-5 pb-6 mt-6 bg-white">
                  <h3 className="mb-2 text-lg">Uploaded KYC Documents</h3>
                  <Formik
                    enableReinitialize
                    initialValues={{
                      fileUploads: { ...row.original?.fileUploads },
                    }}
                    onSubmit={() => null}
                  >
                    {() => {
                      return (
                        <div className="pl-4">
                          <Field
                            name="fileUploads"
                            component={FileUploadForm}
                            documentData={
                              row.original.designation === "Company Secretary"
                                ? getCompanySecretaryDocumentData(
                                    row.original.idType
                                  )
                                : getDocumentData(row.original.idType)
                            }
                            resolvedFields={_get(
                              row.original,
                              "resolvedFields"
                            )}
                            onlyPreview
                            showDocumentLabel
                            addReviewComment={
                              isViewMode
                                ? false
                                : isCOP
                                ? updatedData.fileUploads
                                  ? true
                                  : false
                                : true
                            }
                            hideResolveAllCheckbox={isViewMode ? true : false}
                            handleSaveComment={handleSaveComment}
                            formName="fileUploads"
                            formHelperKey={
                              selectedTab.id === "fileUploads"
                                ? INDIVIDUALS.includes(row.original.idType)
                                  ? "individualOfficial"
                                  : "corporateOfficial"
                                : "beneficialOwner"
                            }
                            updateEffectKey={companyOfficialEffectKey}
                            updateEffectPath={`${officialSliceName}`}
                            formId={_get(row.original, "_id")}
                            resolveAllFieldsCheckbox
                            fileUploadComments={fileUploadComments}
                          />
                        </div>
                      );
                    }}
                  </Formik>
                </div>
              </>
            )}
            {selectedTab.id === "changedDocuments" && (
              <>
                {actionType !== "signature" &&
                row.original.status !==
                  Constants.MAINTAIN_COMPANY_CORRECTIONS_STATUSES
                    .CHANGES_SIGNATURE ? (
                  <div className="bg-white py-4">
                    <div className="flex flex-col py-4 px-2">
                      <h3 className="font-semibold text-slate-800">
                        Document Selected:
                      </h3>
                      <div className="flex px-2 py-2 space-x-2">
                        <Checkbox
                          name="Signed Documents"
                          label="Signed Documents"
                          checked={
                            row.original?.uploadChangeDocument.modeType ===
                            "pre-signed-documents"
                          }
                          disabled
                        />
                        <Checkbox
                          name="Not Signed Documents"
                          label="Not Signed Documents"
                          checked={
                            row.original?.uploadChangeDocument.modeType ===
                            "not-signed-documents"
                          }
                          disabled
                        />
                      </div>
                    </div>
                    <h3 className="font-semibold text-slate-800 px-2">
                      Uploaded File:
                    </h3>
                    <Formik
                      enableReinitialize
                      initialValues={{
                        fileUploads: {
                          ...row.original.uploadChangeDocument.fileUploads,
                        },
                      }}
                      onSubmit={() => null}
                    >
                      {() => (
                        <div className="pl-4">
                          <Field
                            name="fileUploads"
                            component={FileUploadForm}
                            documentData={getChangedDocumentsModuleData(
                              "changeDocuments"
                            )}
                            resolvedFields={_get(
                              row.original.uploadChangeDocument,
                              "resolvedFields"
                            )}
                            onlyPreview
                            showDocumentLabel
                            addReviewComment={
                              isViewMode
                                ? false
                                : isCOP
                                ? updatedData.fileUploads
                                  ? true
                                  : false
                                : true
                            }
                            hideResolveAllCheckbox={isViewMode ? true : false}
                            handleSaveComment={handleSaveComment}
                            formName="uploadChangeDocuments"
                            formHelperKey="ManagerCompanyDocument"
                            updateEffectKey={companyOfficialEffectKey}
                            updateEffectPath={`${officialSliceName}.uploadChangeDocument`}
                            formId={_get(
                              row.original.uploadChangeDocument,
                              "_id"
                            )}
                            resolveAllFieldsCheckbox
                            editorKey={
                              row.original.uploadChangeDocument.fileName
                            }
                            documentName="Consent To Act"
                            comments={changeDocumentsComments.filter(
                              (comment) =>
                                comment.formName === "uploadChangeDocuments"
                            )}
                          />
                        </div>
                      )}
                    </Formik>
                  </div>
                ) : (
                  <ChangeDocumentSignature
                    row={row}
                    setSingeDocPayload={setSingeDocPayload}
                  />
                )}
              </>
            )}

            {selectedTab.id === "directorApprovalDocs" && (
              <div className="bg-white py-4 mt-4">
                <span className="px-2">
                  Uploaded documents for director Approval
                </span>
                <div className="flex flex-col py-4 px-2">
                  <h3 className="font-semibold text-slate-800">
                    Document Selected:
                  </h3>
                  <div className="flex px-2 py-2 space-x-2">
                    <Checkbox
                      name="Signed Documents"
                      label="Signed Documents"
                      checked={
                        row.original.uploadDirectorApprovalDocs.modeType ===
                        "pre-signed-documents"
                      }
                      disabled
                    />
                    <Checkbox
                      name="notSIgnedDocuments"
                      label="Not Signed Documents"
                      checked={
                        row.original.uploadDirectorApprovalDocs.modeType ===
                        "not-signed-documents"
                      }
                      disabled
                    />
                  </div>
                </div>
                <div className="py-4">
                  <h3 className="font-semibold text-slate-800 px-2">
                    Uploaded File:
                  </h3>
                  <Formik
                    enableReinitialize
                    initialValues={{
                      fileUploads: {
                        ...row.original.uploadDirectorApprovalDocs.fileUploads,
                      },
                    }}
                    onSubmit={() => null}
                  >
                    {() => {
                      return (
                        <div className="pl-4">
                          <Field
                            name="fileUploads"
                            component={FileUploadForm}
                            documentData={getChangedDocumentsModuleData(
                              "directorApprovalDocs"
                            )}
                            resolvedFields={_get(
                              row.original.uploadDirectorApprovalDocs,
                              "resolvedFields"
                            )}
                            onlyPreview
                            showDocumentLabel
                            addReviewComment={true}
                            hideResolveAllCheckbox={false}
                            handleSaveComment={handleSaveComment}
                            formName="uploadChangeDocuments"
                            formHelperKey="ManagerCompanyDocument"
                            updateEffectKey={companyOfficialEffectKey}
                            updateEffectPath={`${officialSliceName}.uploadDirectorApprovalDocs`}
                            formId={_get(
                              row.original.uploadDirectorApprovalDocs,
                              "_id"
                            )}
                            resolveAllFieldsCheckbox
                            editorKey={
                              row.original.uploadDirectorApprovalDocs.fileName
                            }
                            documentName="Board Resolutions"
                          />
                        </div>
                      );
                    }}
                  </Formik>
                </div>
              </div>
            )}
            {selectedTab.id === "jointShareholderApprovalDocs" && (
              <div className="bg-white py-4 mt-4">
                <span className="px-2">
                  Uploaded documents for Shareholder Approval
                </span>
                <div className="flex flex-col py-4 px-2">
                  <h3 className="font-semibold text-slate-800">
                    Document Selected:
                  </h3>
                  <div className="flex px-2 py-2 space-x-2">
                    <Checkbox
                      name="Signed Documents"
                      label="Signed Documents"
                      checked={
                        row.original.uploadDirectorApprovalDocs.modeType ===
                        "pre-signed-documents"
                      }
                      disabled
                    />
                    <Checkbox
                      name="notSIgnedDocuments"
                      label="Not Signed Documents"
                      checked={
                        row.original.uploadDirectorApprovalDocs.modeType ===
                        "not-signed-documents"
                      }
                      disabled
                    />
                  </div>
                </div>
                <div className="py-4">
                  <h3 className="font-semibold text-slate-800 px-2">
                    Uploaded File:
                  </h3>
                  <Formik
                    enableReinitialize
                    initialValues={{
                      fileUploads: {
                        BODResolution:
                          row.original.uploadDirectorApprovalDocs.fileName,
                      },
                    }}
                    onSubmit={() => null}
                  >
                    {() => {
                      return (
                        <div className="pl-4">
                          <Field
                            name="fileUploads"
                            component={FileUploadForm}
                            documentData={
                              row.original.uploadDirectorApprovalDocs
                                .modeType === "not-signed-documents" &&
                              row.original.uploadDirectorApprovalDocs
                                .subModeType === "self-resolution-type"
                                ? getChangedDocumentsModuleData(
                                    "ownConsentResolutionType",
                                    row.original?.idType
                                  )
                                : row.original.uploadDirectorApprovalDocs
                                    .modeType === "pre-signed-documents" &&
                                  row.original.uploadDirectorApprovalDocs
                                    .subModeType === "self-resolution-type"
                                ? getChangedDocumentsModuleData(
                                    "approvedChangesDocuments",
                                    row.original?.idType
                                  )
                                : ""
                            }
                            resolvedFields={_get(
                              row.original,
                              "resolvedFields"
                            )}
                            onlyPreview
                            showDocumentLabel
                            addReviewComment={true}
                            hideResolveAllCheckbox={isViewMode}
                            handleSaveComment={handleSaveComment}
                            formName="uploadDocuments"
                            formHelperKey={
                              selectedTab.id === "fileUploads"
                                ? INDIVIDUALS.includes(row.original?.idType)
                                  ? "individualOfficial"
                                  : "corporateOfficial"
                                : "beneficialOwner"
                            }
                            updateEffectKey={companyOfficialEffectKey}
                            updateEffectPath={officialSliceName}
                            formId={_get(row.original, "_id")}
                            resolveAllFieldsCheckbox
                          />
                        </div>
                      );
                    }}
                  </Formik>
                </div>
              </div>
            )}
            {selectedTab.id === "manualBridge" && !manualBridge && (
              <div className="px-8 pt-5 pb-6 mt-6 bg-white">
                <div className="flex flex-col">
                  <small>
                    The required documents are populated manually from the
                    ECitizen and uploaded for electronic signing. Once all the
                    documents have been uploaded for signing the submit button
                    for signature becomes active
                  </small>
                  <Button
                    className="self-start mt-4 w-auto"
                    onClick={() => setManualBridge(true)}
                  >
                    Upload Forms
                  </Button>
                </div>
              </div>
            )}
            {manualBridge && (
              <div className="px-8 pt-5 pb-6 mt-6 bg-white">
                <h3 className="mb-2 text-lg">Uploaded incorporation forms</h3>
                <small>
                  Please upload the incorporation forms generated from the BRS
                  portal, to be signed by the promoters and subscribers of the
                  company
                </small>
                <div className="p-4">
                  <label
                    htmlFor="brsRefNumber"
                    className="block text-sm font-medium text-gray-700"
                  >
                    BRS Reference Number
                  </label>
                  <div className="mt-1">
                    <input
                      type="string"
                      id="brsRefNumber"
                      value={brsRefNumber}
                      onChange={handleInputChange}
                      className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      placeholder="Enter BRS Reference Number"
                      style={{ width: "300px" }}
                    />
                  </div>
                </div>
                <Formik
                  enableReinitialize
                  initialValues={{
                    fileUploads: { ...orgAdminReviewDocuments },
                  }}
                  validationSchema={validationSchema}
                  onSubmit={async (values, { validateForm }) => {
                    // Trigger validation and check if all fields are valid
                    await checkValidation(validateForm);
                  }}
                >
                  {({ validateForm }) => (
                    <>
                      <div className="pl-4">
                        <Field
                          name="fileUploads"
                          component={FileUploadForm}
                          documentData={ORG_ADMIN_OFFICIAL_REVIEW}
                          disabled={false}
                          selectedFiles={selectedFiles}
                          appendSetSelectedState={true}
                          setSelectedFiles={setSelectedFiles}
                          isOrgAdminReview={true}
                        />
                        <ErrorMessage
                          name="fileUploads"
                          component="div"
                          className="text-red-500 mt-2"
                        />
                      </div>
                    </>
                  )}
                </Formik>
              </div>
            )}
            {selectedTab.id === "brsUploads" && (
              <div class="container mx-auto px-4 py-8">
                <p class="text-sm text-gray-600 mb-4">
                  Documents that have comments will not be able to be processed
                  and sent back to applicant for correction. If all the uploaded
                  documents are correct proceed to save and proceed
                </p>
                <div class="flex space-x-4">
                  <div class="flex-1 bg-gray-100 rounded-md shadow-md p-4">
                    <h2 class="text-lg font-bold mb-4">Unsigned</h2>
                    <Formik
                      // enableReinitialize
                      initialValues={{
                        fileUploads: {
                          ...transformOrgAdminFileUploads(
                            row.original.orgAdminReview
                          ),
                        },
                      }}
                      onSubmit={() => null}
                    >
                      {() => {
                        return (
                          <div className="pl-4">
                            <Field
                              name="fileUploads"
                              component={FileUploadForm}
                              documentData={ORG_ADMIN_OFFICIAL_REVIEW}
                              onlyPreview
                              isViewMode={isViewMode}
                              showDocumentLabel
                              showResolveAllFieldsCheckbox={false}
                            />
                          </div>
                        );
                      }}
                    </Formik>
                  </div>
                  <div class="flex-1 bg-white rounded-md shadow-md p-4">
                    <h2 class="text-lg font-bold mb-4">Signed</h2>
                    <Formik
                      enableReinitialize
                      initialValues={{
                        fileUploads: {
                          ...row.original.orgAdminSignedDocuments,
                        },
                      }}
                      onSubmit={() => null}
                    >
                      {() => {
                        return (
                          <div className="pl-4">
                            <Field
                              name="fileUploads"
                              component={FileUploadForm}
                              documentData={ORG_ADMIN_OFFICIAL_REVIEW}
                              onlyPreview
                              showDocumentLabel
                              resolvedFields={_get(
                                row.original.orgAdminSignedDocuments,
                                "resolvedFields"
                              )}
                              addReviewComment
                              hideResolveAllCheckbox
                              handleSaveComment={handleSaveComment}
                              formName="orgAdminSignedDocuments"
                              updateEffectKey={companyOfficialEffectKey}
                              updateEffectPath={officialSliceName}
                              formId={_get(row.original, "_id")}
                              comments={adminDocumentsComments.filter(
                                (comment) =>
                                  comment.formName === "adminDocumentsSignature"
                              )}
                              commentPath={"brsUploads"}
                            />
                          </div>
                        );
                      }}
                    </Formik>
                    {row.original.orgAdminReviewII.fileUploads.length > 0 ? (
                      <Formik
                        // enableReinitialize
                        initialValues={{
                          fileUploads: {
                            ...transformOrgAdminFileUploads(
                              row.original.orgAdminReviewII
                            ),
                          },
                        }}
                        onSubmit={() => null}
                      >
                        {() => {
                          return (
                            <div className="pl-4">
                              <Field
                                name="fileUploads"
                                component={FileUploadForm}
                                documentData={ORG_ADMIN_OFFICIAL_REVIEW_II}
                                onlyPreview={true}
                                isViewMode={isViewMode}
                                showDocumentLabel
                                resolvedFields={_get(
                                  row.original.orgAdminReviewII,
                                  "resolvedFields"
                                )}
                                addReviewComment={true}
                                hideResolveAllCheckbox={true}
                                handleSaveComment={handleSaveComment}
                                formName="orgAdminReviewII"
                                updateEffectKey={companyOfficialEffectKey}
                                updateEffectPath={`${officialSliceName}.orgAdminReviewII`}
                                formId={_get(row.original, "_id")}
                              />
                            </div>
                          );
                        }}
                      </Formik>
                    ) : (
                      <>
                        <Formik
                          // enableReinitialize
                          initialValues={{
                            fileUploads:
                              {
                                ...transformOrgAdminFileUploads(
                                  row.original.orgAdminReviewII
                                ),
                              } || null,
                          }}
                          onSubmit={() => null}
                        >
                          {() => {
                            return (
                              <div className="pl-4">
                                {/* <Field
                                  name="fileUploads"
                                  component={FileUploadForm}
                                  documentData={ORG_ADMIN_OFFICIAL_REVIEW_II}
                                  disabled={false}
                                  selectedFiles={selectedFiles}
                                  setSelectedFiles={setSelectedFiles}
                                  isOrgAdminReview={true}
                                /> */}
                              </div>
                            );
                          }}
                        </Formik>
                        {/* <button
                                                    className="px-4 py-1 mx-4 bg-gray-200 shadow-sm rounded-md"
                                                    onClick={brsFillingReceiptUpload}
                                                    disabled={fillingReceipt}
                                                >
                                                    {fillingReceipt ? (
                                                        <div className="flex">
                                                            <SpinnerIcon />
                                                            uploading...
                                                        </div>
                                                    ) : (
                                                        <> Upload</>
                                                    )}
                                                </button> */}
                      </>
                    )}
                  </div>
                </div>
                <div class="mt-4">
                  <div class="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      onChange={() =>
                        setConfirmationCheckBox(!confirmationCheckBox)
                      }
                      class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
                    />
                    <span class="text-gray-900">
                      Are you sure you want to approve the following details
                    </span>
                  </div>
                </div>
              </div>
            )}
            {selectedTab.id === "confirmation" && (
              <Status
                submitToLabel={submitToLabel}
                setDisableSubmitBtn={setDisableSubmitBtn}
                agreeToSubmit={agreeToSubmit}
                agreeToTerms={agreeToTerms}
                setAgreeToSubmit={setAgreeToSubmit}
                setAgreeToTerms={setAgreeToTerms}
              />
            )}
            <div className="flex justify-between">
              {!isFirstStep && (
                <button
                  onClick={goToPrevStep}
                  className="flex items-start float-right py-2 font-semibold rounded text-primary mt-7"
                >
                  <span className="flex items-center mr-4 h-7">
                    <ChevronLeftIcon
                      className="flex-shrink-0 w-5 h-5"
                      aria-hidden="true"
                    />
                  </span>
                  <p className="font-semibold">Review previous step</p>
                </button>
              )}
              {isLastStep && callFrom !== "transaction" ? (
                <button
                  onClick={() => handleConfirmDetails()}
                  // disabled={
                  //   submitting ||
                  //   !agreeToSubmit ||
                  //   !agreeToTerms ||
                  //   (row.original.status === "ADMIN-REVIEW" &&
                  //     !confirmationCheckBox)
                  // }
                  className={`flex items-center px-4 py-2 mb-2 font-semibold text-white rounded bg-green-focused mt-7 ${
                    submitting ||
                    !agreeToSubmit ||
                    !agreeToTerms ||
                    (row.original.status === "ADMIN-REVIEW" &&
                      !confirmationCheckBox)
                      ? "cursor-not-allowed"
                      : ""
                  }`}
                >
                  <p>
                    {submitting ? (
                      <div className="flex">
                        <SpinnerIcon />
                        submitting...
                      </div>
                    ) : unresolvedComments.length > 0 ? (
                      "Submit back to Applicant"
                    ) : (
                      "Confirm details"
                    )}
                  </p>
                  {!isViewMode && (
                    <span className="flex items-center ml-4 text-white h-7">
                      <ChevronRightIcon
                        className="flex-shrink-0 w-5 h-5"
                        aria-hidden="true"
                      />
                    </span>
                  )}
                </button>
              ) : isLastStep && callFrom === "transaction" ? (
                <button
                  onClick={onLastStepClose}
                  className="flex items-start float-right py-2 ml-auto font-semibold rounded text-primary mt-7"
                >
                  <p className="font-semibold">Close</p>
                  <span className="flex items-center ml-4 h-7">
                    <ChevronRightIcon
                      className="flex-shrink-0 w-5 h-5"
                      aria-hidden="true"
                    />
                  </span>
                </button>
              ) : (
                <button
                  onClick={goToNextStep}
                  className="flex items-start float-right py-2 ml-auto font-semibold rounded text-primary mt-7"
                >
                  <p className="font-semibold">
                    {isViewMode ? "View Next Step" : "Review next step"}
                  </p>
                  <span className="flex items-center ml-4 h-7">
                    <ChevronRightIcon
                      className="flex-shrink-0 w-5 h-5"
                      aria-hidden="true"
                    />
                  </span>
                </button>
              )}
            </div>
          </div>
        </div>
      </td>
    </tr>
  );
}

export default OfficialSubRow;
